module.exports = __webpack_public_path__ + "img/bed.svg";